import { useState } from 'react';
import './results-gate.styles.scss';
import TeamBadge from '@/components/SHARED/team-badge/team-badge.component';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';

// Shown in place of the league pages when the manager's team has played
// games they haven't seen: watch the first one, or go straight to the
// result. Nothing here gives the score away.
// games: the unseen schedule games, oldest first. teams: summary/teams.
const ResultsGate = ({ games, teams, teamId, onWatch, onResults, onStopAsking }) => {

    const [ busy, setBusy ] = useState(null);
    const many = games.length > 1;

    async function run(key, fn) {
        setBusy(key);
        await fn();
        setBusy(null);
    }

    return (
        <div className='results-gate' role='dialog' aria-modal='true' aria-labelledby='results-gate-title'>
            <div className='g-card gate-card'>
                <h2 id='results-gate-title'>{many ? `${games.length} new games are final` : 'Your game is final'}</h2>
                <p className='meta'>Watch the play-by-play unfold, or skip straight to the {many ? 'results' : 'result'}.</p>
                <ul className='gate-games'>
                    {games.map(g => {
                        const home = g.home === teamId;
                        const opp = teams?.[home ? g.away : g.home];
                        return (
                            <li key={g.id}>
                                <TeamBadge team={opp} size='sm' />
                                <span>
                                    <b>{g.neutral ? 'vs' : home ? 'vs' : 'at'} {opp?.name ?? 'opponent'}</b>
                                    <span className='meta'> · Day {g.day}{g.label ? ` · ${g.label}` : ''}</span>
                                </span>
                            </li>
                        );
                    })}
                </ul>
                <div className='gate-actions'>
                    <button className={`g-button primary ${busy ? 'disabled' : ''}`} disabled={Boolean(busy)} onClick={() => run('watch', () => onWatch(games[0]))}>
                        {busy === 'watch' ? <ThreeDotsLoader /> : many ? 'Watch them in order' : 'Watch it'}
                    </button>
                    <button className={`g-button ${busy ? 'disabled' : ''}`} disabled={Boolean(busy)} onClick={() => run('results', onResults)}>
                        {busy === 'results' ? <ThreeDotsLoader /> : many ? 'Show me the results' : 'Show me the result'}
                    </button>
                </div>
                <button className='gate-stop' disabled={Boolean(busy)} onClick={() => run('stop', onStopAsking)}>
                    Don&apos;t ask me again (you can turn this back on from My Team)
                </button>
            </div>
        </div>
    )
}

export default ResultsGate
